import { Component } from '@angular/core';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app-sidebar.component.html',
    standalone: false
})
export class AppSidebarComponent { }
